import React from 'react'

import styles from './downloadCSVHistoryView.module.scss'
import DownloadCSVForm from '../downloadCSVForm/DownloadCSVForm'

const DownloadHistoryView = ({ downloadClick = () => {} }: { downloadClick?: () => void }) => {
  return (
    <div className={styles['payment-history-modal']}>
      <h3>Download payment history</h3>
      <p>Payment history data will be downloaded in a CSV format (Excel)</p>
      {/* @ts-expect-error TS(2322): Type '{ submitDownload: any; }' is not assignable ... Remove this comment to see the full error message */}
      <DownloadCSVForm submitDownload={downloadClick} />
    </div>
  )
}

export default DownloadHistoryView
